import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Download, Loader2 } from 'lucide-react';

export const FullMenuModal = ({ isOpen, onClose }) => {
  const [menuConfig, setMenuConfig] = useState({ type: 'none', urls: [] });
  const [loading, setLoading] = useState(true);
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      fetch(`${backendUrl}/api/menu`)
        .then(res => res.json())
        .then(data => {
          setMenuConfig(data);
          setLoading(false);
        })
        .catch(err => {
          console.error("Error fetching menu config", err);
          setLoading(false);
        });
    }
  }, [isOpen, backendUrl]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl w-[95vw] md:w-11/12 max-h-[90vh] flex flex-col overflow-hidden bg-card border-border text-card-foreground p-0 rounded-none">
        <DialogHeader className="p-4 md:p-6 pb-2 md:pb-4 flex-shrink-0 border-b border-border/40">
          <DialogTitle className="text-2xl md:text-3xl font-serif text-primary text-center">Teljes Étlap</DialogTitle>
          <DialogDescription className="text-center font-sans tracking-widest uppercase text-[10px] md:text-xs mt-1 md:mt-2">
            aKonyhád! Bisztró
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex-1 overflow-y-auto p-4 md:p-6 bg-secondary/10 flex flex-col items-center">
          {loading ? (
            <div className="flex justify-center items-center h-full min-h-[200px]">
               <Loader2 className="w-8 h-8 animate-spin text-primary" />
            </div>
          ) : menuConfig.type === 'none' || menuConfig.urls.length === 0 ? (
            <div className="flex flex-col justify-center items-center h-full min-h-[200px] text-center px-4">
               <p className="text-muted-foreground font-light text-base md:text-lg">Jelenleg nincs feltöltve étlap.</p>
            </div>
          ) : menuConfig.type === 'pdf' ? (
            <div className="w-full flex flex-col items-center h-full min-h-[50vh]">
              {/* Using an iframe for PDF embedding */}
              <iframe 
                src={`${backendUrl}${menuConfig.urls[0]}#toolbar=0`}
                title="Étlap PDF"
                className="w-full flex-1 min-h-[60vh] border border-border/40 shadow-sm mb-6"
              >
                <p>A böngésződ nem támogatja a PDF megjelenítést.</p>
              </iframe>
              
              <Button asChild className="w-full max-w-sm font-sans tracking-widest uppercase text-[10px] md:text-xs h-12 md:h-14 bg-primary text-primary-foreground hover:bg-primary/90 mt-auto">
                 <a href={`${backendUrl}${menuConfig.urls[0].split('?')[0]}`} download target="_blank" rel="noopener noreferrer">
                   <Download className="w-4 h-4 mr-2" />
                   Étlap letöltése PDF-ként
                 </a>
              </Button>
            </div>
          ) : (
            <div className="w-full flex flex-col items-center gap-6 md:gap-8">
              {menuConfig.urls.map((url, idx) => (
                <div key={idx} className="w-full flex justify-center">
                  <img 
                    src={`${backendUrl}${url}`} 
                    alt={`Étlap oldal ${idx + 1}`} 
                    className="w-full h-auto object-contain shadow-md border border-border/40"
                    onError={(e) => {
                      // Fallback if image fails to load
                      e.target.onerror = null; 
                      e.target.src = "https://placehold.co/800x1200?text=K%C3%A9p+nem+tal%C3%A1lhat%C3%B3";
                    }}
                  />
                </div>
              ))}
              <Button asChild className="w-full max-w-sm font-sans tracking-widest uppercase text-[10px] md:text-xs h-12 md:h-14 bg-primary text-primary-foreground hover:bg-primary/90 mt-4">
                 <a href={`${backendUrl}${menuConfig.urls[0].split('?')[0]}`} download target="_blank" rel="noopener noreferrer">
                   <Download className="w-4 h-4 mr-2" />
                   Kép letöltése
                 </a>
              </Button>
            </div>
          )}
        </div>
        
        <div className="p-3 md:p-4 flex-shrink-0 flex justify-center border-t border-border/40 bg-card">
            <Button onClick={onClose} variant="outline" className="text-[10px] md:text-xs tracking-widest uppercase border-foreground text-foreground hover:bg-foreground hover:text-background w-full max-w-xs h-10 md:h-12">
                Bezárás
            </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
